module.exports = __webpack_public_path__ + "media/images/talent/case1-img01-b1b9c75a5107075cdb2022d861430d9b.png";